export class ExclusiveDomain{

  toHealthProfessionals: boolean;
  isCareMaterialOrganizationSurvey: boolean;
  areSurveysWithoutIntrusiveness: boolean;
  isQuestionnaireValidation: boolean;
  isBibliographicReview: boolean;

}
